import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { AddHostPayload, HostManagement, ToggleHostStatusPayload } from './hostManagement.types';

const toggleHostStatus = (client: AxiosInstance) => async (payload: ToggleHostStatusPayload) => {
  return (
    await client.post<{ message: string; data: HostManagement }>(API_ROUTES.BLOCK_UNBLOCK_HOST, {
      clubId: payload.clubId,
      hostId: payload.hostId,
      status: payload.status,
    })
  ).data;
};

const createHostInfo = (client: AxiosInstance) => async (payload: AddHostPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_HOST_INFO, payload)).data;
};

const manageHostInfo = (client: AxiosInstance) => async (payload: AddHostPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_HOST_DETAILS, payload)).data;
};

export const hostManagementMutations = { toggleHostStatus, createHostInfo, manageHostInfo };
